import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
} from "@material-ui/core";
import Button from "components/CustomButtons/Button";

export default function CreateArtifactProjectModal({
  newProjectDetails,
  setNewProjectDetails,
  createProjectModal,
  handleCreateProjectModalClose,
  handleCreateProject,
}) {
  return (
    <Dialog
      open={createProjectModal}
      onClose={handleCreateProjectModalClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Create New Artifact Project</DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" gap={1}>
        
          <TextField
            label="Project Name"
            value={newProjectDetails.name}
            onChange={(e) =>
              setNewProjectDetails({
                ...newProjectDetails,
                name: e.target.value,
              })
            }
            fullWidth
            margin="normal"
            required
          />
          <TextField
            label="Brief Description"
            value={newProjectDetails.description}
            onChange={(e) =>
              setNewProjectDetails({
                ...newProjectDetails,
                description: e.target.value,
              })
            }
            fullWidth
            multiline
            rows={4}
            margin="normal"
            required
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCreateProjectModalClose} color="transparent">
          Cancel
        </Button>
        <Button
          onClick={handleCreateProject}
          color="quCreateColor"
          disabled={!newProjectDetails.name.trim()}
        >
          Create Project
        </Button>
      </DialogActions>
    </Dialog>
  );
}